<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Resources</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/branding"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Branding_Module_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Branding Images</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-returns"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Top_Returns_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Scheme Returns</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancelumpsum"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Lumpsum.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/schemeperformancecompare"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Performance_Comparison.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>Best Scheme Performance</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/value-add-service/scheme-nav"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/NAVs_report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme NAV</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a
              routerLink="/value-add-service/scheme-dividend"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Dividends_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Scheme Dividend</span>
            </a>
          </li>
          <!-- <li class="SideMenuLinksInner">
                      <a routerLink='/value-add-service/new-nfo' routerLinkActive='active'>
                        <img src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg" width="25" class="SideMenuIcon svg" type="image/svg+xml"
                          pluginspage="http://www.adobe.com/svg/viewer/install/" />
                        <span>NFO</span>
                      </a>
                    </li> -->
          <li class="SideMenuLinksInner">
            <a routerLink="/value-add-service/forms" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/MF_Forms.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>MF Forms</span>
            </a>
          </li>
          <li class="SideMenuLinksInner" *ngIf="IsSubscribed">
            <a
              routerLink="/value-add-service/scheduleclient"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/Schedule_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Schedule Report (Beta)</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate">
      <div>
        <div *ngIf="!IsMobile" class="SectionHeading">Scheme NAV</div>

        <form autocomplete="off" [formGroup]="Transactionform">
          <div class="MinLeftFormHeightTransact">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="AMC"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect1"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.AMC.errors
                    }">
                    <option value="" disabled="true" selected>
                      Select AMC
                    </option>
                    <option
                      *ngFor="let AMC of SelectedAMC"
                      [value]="AMC.VALUEFIELD">
                      {{ AMC.TEXTFIELD }}
                    </option>
                  </select>
                  <!-- <ng-multiselect-dropdown-angular7 [ngModelOptions]="{standalone: true}"
                                [placeholder]="'Select AMC '" [data]="SelectedAMC"
                                [(ngModel)]="SelectedAMC" [settings]="dropdownSettings"
                                (onSelect)="onItemSelect($event)" (onDeSelect)="onItemSelect($event)"
                                (onSelectAll)="onItemSelectDeselectAll($event,0)"
                                (onDeSelectAll)="onItemSelectDeselectAll($event,1)">
                            </ng-multiselect-dropdown-angular7> -->
                  <label>AMC</label>
                  <div
                    *ngIf="TransactionSubmitted && l.AMC.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.AMC.errors.required">Please Select AMC</div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <select
                    formControlName="Scheme"
                    class="form-control CommonSelectBox TbxMarginBtm CustomSelect2"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.Scheme.errors
                    }">
                    <option value="" disabled="true" selected>
                      Select Scheme
                    </option>
                    <option
                      *ngFor="let Scheme of SelectedScheme"
                      [value]="Scheme.VALUEFIELD">
                      {{ Scheme.TEXTFIELD }}
                    </option>
                  </select>
                  <label>Scheme</label>
                  <div
                    *ngIf="TransactionSubmitted && l.Scheme.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.Scheme.errors.required">
                      Please Select Scheme
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row">
                            <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                                <div class="has-float-label">
                                    <select formControlName="Asset_type"
                                        class="form-control CommonSelectBox TbxMarginBtm CustomSelect6"
                                        [ngClass]="{ 'is-invalid': TransactionSubmitted && l.TransactionSubType.errors }">
                                        <option value="0" disabled='true'>Asset Type</option>
                                        <option value="1" Selected>Equity</option>
                                        <option value="2">Debt</option>
                                        <option value="3">Hybrid</option>
                                        <option value="4">Commodity</option>
                                    </select>
                                    <label>Asset Class</label>
                                    <div *ngIf="TransactionSubmitted && l.Asset_type.errors"
                                        class="invalid-feedback">
                                        <div *ngIf="l.Asset_type.errors.required">Please Select Asset Class</div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                                <div class="has-float-label">
                                    <select formControlName="SubAsset_type"
                                        class="form-control CommonSelectBox TbxMarginBtm CustomSelect3"
                                        [ngClass]="{ 'is-invalid': TransactionSubmitted && l.SubAsset_type.errors }">
                                        <option value="0" disabled='true' selected>Select Sub Asset Type</option>
                                        <option *ngFor="let nature of SelectedSubAsset" [value]="nature.VALUEFIELD">
                                            {{nature.TEXTFIELD}}</option>
                                    </select>
                                    <label>Sub Asset Class</label>
                                    <div *ngIf="TransactionSubmitted && l.SubAsset_type.errors" class="invalid-feedback">
                                        <div *ngIf="l.SubAsset_type.errors.required">Please Select Sub Asset Class</div>
                                    </div>
                                </div>
                            </div>
                        </div>                        -->

            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <input
                    type="text"
                    id="FromDate"
                    formControlName="FromDate"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.FromDate.errors
                    }"
                    class="form-control CommonTextBox TbxMarginBtm clsDatePickerFromDate clsCommonDatePicker"
                    placeholder="&nbsp;" />
                  <label for="FromDate">From Date</label>
                  <div
                    *ngIf="TransactionSubmitted && l.FromDate.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.FromDate.errors.required">
                      Please Select From Date
                    </div>
                    <div *ngIf="l.FromDate.errors.pattern">
                      Please Enter Valid Date
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6 col-xs-12 InputBoxOuter">
                <div class="has-float-label">
                  <input
                    type="text"
                    formControlName="ToDate"
                    id="ToDate"
                    [ngClass]="{
                      'is-invalid': TransactionSubmitted && l.ToDate.errors
                    }"
                    class="form-control CommonTextBox TbxMarginBtm clsDatePickerToDate clsCommonDatePicker"
                    placeholder="&nbsp;" />
                  <label for="ToDate">To Date</label>
                  <div
                    *ngIf="TransactionSubmitted && l.ToDate.errors"
                    class="invalid-feedback">
                    <div *ngIf="l.ToDate.errors.required">
                      Please Select To Date
                    </div>
                    <div *ngIf="l.ToDate.errors.pattern">
                      Please Enter Valid Date
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="SubmitMarginTop">
            <button
              class="CommonSubmitButton"
              [disabled]="Transactionform.value == '' || !Transactionform.valid"
              (click)="onSubmitTransaction()">
              Show Report
            </button>
          </div>
          <!-- <div class="SubmitMarginTop">
                      <button class="CommonSubmitButton" [disabled]="" (click)="ExportTOExcelALL()">Export To Excel</button>
                  </div> -->
          <!--<h6>{{Transactionform.value | json}}</h6> -->
        </form>
      </div>
    </div>
  </div>
  <div id="TblReportSection">
    <div
      [ngClass]="IsShowReport ? 'd-block' : 'd-none'"
      class="MainInnerFormWithoutFlex mt-0">
      <div class="SectionTopHeading w-100">
        <span class="ReportHead"><b>Scheme Historical NAV</b></span>
        <div class="RightSideTabs">
          <ul class="nav nav-tabs p-0">
            <button class="ml-2" (click)="ExportTOExcelALL()">
              <img
                src="../../assets/images/IFA/Excel_Export.svg"
                class="ExportToIcon"
                type="image/svg+xml"
                fill="#fff"
                width="12px"
                style="width: 27px !important; height: 29px !important"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
            </button>
          </ul>
        </div>
      </div>
      <div class="">
        <!-- <div class="col-4">
                </div> -->

        <div *ngIf="!IsMobile" class="tab-content pt-0">
          <div id="SchemeReport" class="tab-pane fade show active">
            <table id="ReportTable" class="CommonTable ClsReportTable w-100">
              <thead>
                <tr>
                  <th class="no-sort">AMC Name</th>
                  <th class="no-sort">Scheme Name</th>
                  <th class="no-sort">Sub Asset Class</th>
                  <th class="no-sort">Scheme Type</th>
                  <th class="no-sort">Scheme Option</th>
                  <!-- <th>Asset Class</th>
                                            <th>Asset Category</th>                             -->
                  <th class="text-right"><span>NAV Date</span></th>
                  <th class="no-sort text-right">NAV</th>
                  <!-- <th>Sub Asset Category</th> -->
                  <!-- <th>Schemecode</th>
                                            <th>AmcCode</th>                                             -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of ReportData">
                  <td class="no-sort">{{ c.AMC_Name }}</td>
                  <td class="no-sort">{{ c.Scheme_Name }}</td>
                  <td class="no-sort">{{ c.Sub_Asset_Class }}</td>
                  <td class="no-sort">{{ c.Scheme_Type }}</td>
                  <td class="no-sort">{{ c.Scheme_Option }}</td>
                  <!-- <td>{{c.Asset_Class}}</td>
                                            <td>{{c.Asset_Category}}</td>
                                            <td>{{c.Sub_Asset_Category}}</td>                            -->
                  <td class="text-right">
                    {{ c.NavDate.substring(0, 10) | date: 'dd/MM/yyyy' }}
                  </td>
                  <td class="no-sort text-right">
                    {{ c.NAV | number: '1.4-4' }}
                  </td>
                  <!-- <td>{{c.Schemecode}}</td>
                                            <td>{{c.AmcCode}}</td>                                             -->
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <span *ngIf="!IsMobile">
    <app-footer></app-footer>
  </span>
</div>
